import { CommonModule } from '@angular/common';
import { Component, computed, input, signal } from '@angular/core';
import { DepositButtonComponent } from './deposit-button/deposit-button.component';
import { WalletRowComponent } from './wallet-row/wallet-row.component';
import { WalletSelectComponent } from './wallet-row/wallet-select/wallet-select.component';
import { Router } from '@angular/router';
import { ConnectionPositionPair, OverlayModule } from '@angular/cdk/overlay';

@Component({
  selector: 'app-wallet-balance',
  templateUrl: './wallet-balance.component.html',
  styleUrls: ['./wallet-balance.component.scss'],

  imports: [CommonModule, DepositButtonComponent, WalletRowComponent, WalletSelectComponent, OverlayModule],
})
export class WalletBalanceComponent {
  type = input<'simple' | 'complete'>('complete');
  animation = signal<boolean>(false);
  isOpen = signal<boolean>(false);
  canOpen = computed(() => this.type() == 'complete' && !this.isStage);
  positions = [
    new ConnectionPositionPair({ originX: 'center', originY: 'bottom' }, { overlayX: 'center', overlayY: 'top' }, 0, 8),
  ];
  constructor(private router: Router) {}

  toggle() {
    if (this.canOpen()) {
      if (this.isOpen()) {
        setTimeout(() => this.isOpen.set(false), 200);
        this.animation.set(false);
      } else {
        setTimeout(() => this.animation.set(true), 200);
        this.isOpen.set(true);
      }
    }
  }
  get isStage() {
    return this.router.url.includes('stage');
  }
}
